import * as React from "react";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  DataGrid,
} from "@mui/x-data-grid";
import { useEffect, useRef, useState } from "react";
import { useAxios } from "../../utils/useAxios";
import { useNavigate } from "react-router";
import { useModal } from "../../hooks/useModal";
import {
  EyeIcon,
  ListIcon,
  PencilIcon,
  PlusIcon,
  Reload,
  RemoveIcon,
} from "../../icons";
import { color } from "@mui/system";

import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";
import { MyDataTable } from "./styles/DataTable.style";
import { Button, Link } from "@mui/material";
import { TopMenu } from "./json/TopMenu";
import { useResizeObserver } from "../../utils/Resize";
import { bsEncrypt } from "../../utils/storage";
import { Modal } from "../../components/ui/modal";

interface Props {
  formId: string;
  source?: any;
  crud?: any;
}

export default function DataTableTabs({ formId, source, crud }: Props) {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  const divRef = React.useRef<HTMLDivElement>(null);
  // const [width, setWidth] = useState(0);
  const { width, height } = useResizeObserver(divRef);

  const { isOpen, openModal, closeModal } = useModal();
  const [filedata, setFiledata] = useState("");
  const [openRowId, setOpenRowId] = useState<number | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenRowId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const toggleDropdown = (rowId: number) => {
    setOpenRowId((prevId) => (prevId === rowId ? null : rowId));
  };

  const { res, mutate, isPending, error } = useAxios({
    url: "/api/auth/tabledata",
  });

  useEffect(() => {
    if (formId) {
      mutate({
        formId: formId,
        source: source,
      });
    }
  }, [formId]);

  const openImg = (e: any) => {
    openModal();
    setFiledata(e);
  };

  const handleEdit = (id: number) => {
    crud({
      id: id,
      action: "edit",
    });
  };

  const handleDelete = (id: number) => {};
  const handleViwe = (id: number) => {
    crud({
      id: id,
      action: "view",
    });
  };

  if (isPending) return <p>Loading...</p>;
  if (error) return <p>Error fetching data</p>;

  const getTopmenu = TopMenu.filter((item: any) => item?.formId === formId);

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          padding: "10px 10px",
          background: "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
        }}
        className="flex justify-between items-center w-full px-2 py-5 border-b border-gray-400"
      >
        <div className="flex gap-2">
          {/* <Button startIcon={<PlusIcon width={16} height={16} />}>ADD NEW</Button> */}
          {/* {addButton} */}
          <Button startIcon={<Reload width={16} height={16} />}>Reload</Button>
        </div>
        <div className="flex gap-2">
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport />
        </div>
      </GridToolbarContainer>
    );
  }
  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      headerClassName: "sticky-header",
      // cellClassName: "sticky-cell",
      renderCell: (params: any) => {
        const isOpen = openRowId === params.row.id;
        return (
          <div
            className=" gap-1 align-middle h-full"
            ref={isOpen ? dropdownRef : null}
          >
            <button
              data-dropdown-toggle="dropdown"
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click
                toggleDropdown(params.row.id);
              }}
              className="text-white bg-green-700 hover:bg-blue-800  focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-1 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              type="button"
            >
              Actions
              <svg
                className="w-2.5 h-2.5 ms-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </button>
            {isOpen && (
              <div className="z-9999 absolute bg-gray-50 divide-y divide-gray-100 rounded-lg shadow-xl  dark:bg-gray-700">
                <ul
                  className="py-2 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDefaultButton"
                >
                  <li>
                    <Button
                      className="w-full"
                      sx={{
                        justifyContent: "flex-start",
                      }}
                      startIcon={<EyeIcon fill="currentColor" />}
                      onClick={() => handleViwe(params.row.id)}
                    >
                      View
                    </Button>
                  </li>
                  <li>
                    <Button
                      className="w-full"
                      sx={{
                        justifyContent: "flex-start",
                      }}
                      startIcon={<PencilIcon />}
                      onClick={() => handleEdit(params.row.id)}
                    >
                      Edit
                    </Button>
                  </li>
                  <li>
                    <Button
                      className="w-full"
                      sx={{
                        justifyContent: "flex-start",
                      }}
                      startIcon={<ListIcon />}
                    >
                      View History
                    </Button>
                  </li>
                  <li>
                    <Button
                      className="w-full"
                      sx={{
                        justifyContent: "flex-start",
                      }}
                      startIcon={<RemoveIcon />}
                      onClick={() => handleDelete(params.row.id)}
                    >
                      Delete
                    </Button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        );
      },
    },
    ...(res?.data?.headers || []).map((col: any) => ({
      field: col.field,
      headerName: col.headerName || col.title || col.field,
      width: 180,
      renderCell: (params: any) => {
        const value = params.row[col.field];
        // If it's a file upload field and has a PDF path
        // if (col.component === "fileupload" && typeof value === "string" && value.endsWith(".pdf")) {
        // const html = `<a href="#" onclick="popup('${params.row.id}', '${value}')"><i class='fa fa-file-pdf text-red-600'></i></a>`;
        // return <span dangerouslySetInnerHTML={{ __html: html }} />;
        //}
        if (col.field === "file_upload" && typeof value === "string") {
          const html = `<a href="#" onclick="popup('${params.row.id}', '${value}')"><i class='fa fa-file-pdf text-red-600'></i></a>`;
          return (
            <span>
              <Button onClick={() => openImg(value)}>
                <i className="fa fa-file-pdf text-red-600 text-2xl absolute top-[-12px]"></i>
              </Button>
            </span>
          );
        }

        // For other types, render normally
        return <span>{value}</span>;
      },
    })),
  ];
  const rows = res?.data?.data || [];

  const filteredRows = rows.filter((row: any) =>
    Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchText.toLowerCase()),
    ),
  );

  return (
    <>
      <div className="bg-white border p-3">
        <div
          ref={divRef}
          style={{
            minWidth: "150px",
            height: "1px",
            padding: "1px",
          }}
        />
        <label className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
          Search
        </label>
        <input
          type="text"
          placeholder="Search..."
          className="h-9 border w-[300px] px-4 py-1 mb-3 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-white text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <div
          style={{
            width: "100%",
            minHeight: "450px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <MyDataTable
            sx={{
              height: "450px",
              width: `${width ? width : 1000}px`,
              position: "absolute",
              // display:"none"
            }}
            rows={filteredRows}
            columns={columns as any}
            getRowId={(row) =>
              formId === "my_forms" ||
              formId === "my_forms_sections" ||
              formId === "my_forms_columns"
                ? row.formid
                : row.id
            }
            pageSizeOptions={[10]}
            pagination
            paginationMode="client"
            rowHeight={40}
            columnHeaderHeight={30}
            slots={{
              toolbar: CustomToolbar,
            }}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 8, page: 0 }, // Default to 5 records per page
              },
              columns: {
                columnVisibilityModel: {
                  // Hide columns status and traderName
                  // id: formIntData?.idShow || false,
                },
              },
            }}
            getRowClassName={(params: any) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
          />
        </div>
      </div>

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        className="max-w-[1000px] m-4"
        header="View Document"
      >
        <iframe
          src={
            process.env.REACT_APP_BASE_URL +
            `/${filedata}#toolbar=0&navpanes=0&view=FitH`
          }
          width="100%"
          height="400px"
        ></iframe>
      </Modal>
    </>
  );
}
